export const TIER = {
  FREE: 0,
  PLUS: 1,
  PREMIUM: 2,
  DIAMOND: 3,
} as const;

export type Tier = (typeof TIER)[keyof typeof TIER];

export interface CreateViewRequest {
  user_id: string;
  token_address: string;
  device_type: 'desktop' | 'mobile' | 'tablet';
  tier: Tier;
  credits_used: number;
}

export interface ViewHistoryItem {
  user_id: string;
  token_address: string;
  device_type: 'desktop' | 'mobile' | 'tablet';
  tier: Tier;
  credits_used: number;
  created_at: string;
}

export interface ViewHistoryResponse {
  views: ViewHistoryItem[];
  total: number;
  has_more: boolean;
}

export interface ViewHistoryItem {
  view_id: string;
  user_id: string;
  token_address: string;
  device_type: 'desktop' | 'mobile' | 'tablet';
  created_at: string;
  tier: Tier;
  credits_used: number;
}

export interface ViewHistoryResponse {
  history: ViewHistoryItem[];
}
